import React from 'react';

import { Box, Typography } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { useProductCalories } from 'pages/menu/components/product-wizard/use-product-calories';
import { useProductTotalPrice } from 'pages/menu/components/product-wizard/use-product-total-price';

import { useProductWizardContext } from '../../product-wizard';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';

import { OverSodiumLimitWarning } from './over-sodium-limit-warning';
import { ProductPriceCaloriesContainer } from './styled';

interface ProductPriceCaloriesProps {
  showPlusSign?: boolean;
}

export const ProductPriceCalories = ({ showPlusSign }: ProductPriceCaloriesProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  const { selectedProduct, slotsSelections, productQuantity } = useProductWizardContext();
  const { cartIdEditing, id, rewardId } = useProductWizardFlow();
  const { formattedTotalPrice } = useProductTotalPrice({
    id,
    selectedProduct,
    slotsSelections,
    productQuantity,
    cartIdEditing,
    rewardId,
  });
  const calories = useProductCalories(selectedProduct);

  const accessibilityLabel = `${formattedTotalPrice} ${calories}`;

  const fontStyles = isDesktop ? { fontSize: 24 } : styles.priceAndCaloriesText;

  return (
    <Box focusable accessibilityLabel={accessibilityLabel}>
      <ProductPriceCaloriesContainer>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          {formattedTotalPrice && (
            <Typography testID="product-total-price" style={fontStyles}>
              {formattedTotalPrice}
            </Typography>
          )}
          {formattedTotalPrice && calories && <Typography style={fontStyles}>{'  |  '}</Typography>}
          {calories && (
            <Typography testID="product-total-calories" style={fontStyles}>
              {calories}
            </Typography>
          )}
        </View>
        <OverSodiumLimitWarning />
      </ProductPriceCaloriesContainer>
    </Box>
  );
};

const styles = StyleSheet.create({
  priceAndCaloriesText: {
    fontSize: 18,
  },
});
